import { Box, Grid, Stack, Tab, Tabs, Typography } from '@mui/material';
import { CustomMetaTitle, TabPanel } from 'Components';
import {
  useAppSelector,
  useIsDesktop,
  useNotificationsDictionary,
} from 'Hooks';
import { useState } from 'react';
import { NotificationsList } from './NotificationsList';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { NotificationsProvider } from 'Context/NotificationsContext';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

enum VALUE_TYPE {
  documents = 0,
  updates = 1,
}

export const Notifications = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useNotificationsDictionary();

  const [value, setValue] = useState<VALUE_TYPE>(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const mobileListStyle = {
    marginX: 'auto',
    width: '100%',
  };

  const desktopListStyle = {
    marginX: 'auto',
    width: 'min(848px, 75vw)',
  };

  const unreadNotificationsMessages = useAppSelector(
    ({ notifications: { unreadNotificationsMessages } }) =>
      unreadNotificationsMessages
  );

  const unreadNotificationsDocuments = useAppSelector(
    ({ notifications: { unreadNotificationsDocuments } }) =>
      unreadNotificationsDocuments
  );

  const tabStyle = (index: number) => {
    return {
      width: '45%',
      maxWidth: '260px',
      padding: '12px 0',
      marginLeft: index === 0 ? 'auto' : '',
      marginRight: index === 1 ? 'auto' : '',
      fontSize: isDesktop ? '18px' : '16px',
      fontWeight: value === index ? '700' : '',
      borderBottom: value !== index ? '1px solid rgba(23, 82, 175, 0.2)' : '',
    };
  };

  const TabLabelCounter = (counter: number, index: number) => (
    <Grid
      item
      sx={{
        display: 'inline',
        backgroundColor: value === index ? '#1752AF' : '#39546A',
        color: '#FFF',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
      }}
    >
      <Typography fontWeight={700}>{counter}</Typography>
    </Grid>
  );

  const TabLabel = (title: string, index: number) => (
    <Grid container justifyContent={'center'} alignItems={'center'}>
      <Grid item mr={1} sx={{ display: 'inline' }}>
        {title}
      </Grid>
      {index === 0
        ? unreadNotificationsMessages !== 0 &&
          TabLabelCounter(unreadNotificationsMessages, index)
        : unreadNotificationsDocuments !== 0 &&
          TabLabelCounter(unreadNotificationsDocuments, index)}
    </Grid>
  );

  return (
    <>
      <CustomMetaTitle
        title={
          Dictionary[DICTIONARY.MedicationsAndPrescriptionsLobby].personalZone +
          ' - ' +
          Dictionary[DICTIONARY.Notifications].title
        }
      />
      <Stack
        sx={{
          width: '100%',
        }}
      >
        <NotificationsProvider>
          <LinkReturnToMain />
          <Box
            sx={{
              mb: '20px',
              textAlign: 'center',
            }}
          >
            <Typography
              variant='h1'
              mt='76px'
              mb='16px'
              fontWeight={700}
              fontSize={'24px'}
              tabIndex={0}
            >
              {dictionary.title}
            </Typography>
            <Typography>{dictionary.documentsSubTitle[0]}</Typography>
            <Typography mb='40px'>{dictionary.documentsSubTitle[1]}</Typography>
            <Box
              sx={{
                width: isDesktop ? 'min(848px, 75vw)' : '100%',
                height: 'max(65px, 100%)',
                marginX: 'auto',
                backgroundColor: '#FFF',
                boxShadow: '0px 3px 21px rgba(45, 112, 217, 0.15)',
                backdropFilter: 'blur(16.3097px)',
                borderRadius: '16px',
                paddingTop: '17px',
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label='basic tabs example'
              >
                <Tab
                  label={TabLabel(dictionary.updates, 0)}
                  {...a11yProps(0)}
                  sx={tabStyle(0)}
                />
                <Tab
                  label={TabLabel(dictionary.documentsAndMail, 1)}
                  {...a11yProps(1)}
                  sx={tabStyle(1)}
                />
              </Tabs>
            </Box>
          </Box>
          <Box sx={isDesktop ? desktopListStyle : mobileListStyle}>
            <TabPanel value={value} index={0}>
              <NotificationsList index={0} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <NotificationsList index={1} />
            </TabPanel>
          </Box>
        </NotificationsProvider>
      </Stack>
    </>
  );
};
